module.exports = __webpack_public_path__ + "img/cases-brand-vive-5.440d3898.jpg";